import * as React from 'react';
import moment, { Moment } from 'moment';
import { DatePicker } from 'antd';
import { useField, useFormikContext, FormikValues } from 'formik';
import { dateInputUtils } from './dateInputUtils';
import { DatePickerProps } from 'antd/lib/date-picker';
import { PickerDateProps } from 'antd/lib/date-picker/generatePicker';
import { useFormikFormContext } from '../FormikFormContext';
import { IExtraInputProps, useInputProps } from '../hooks/useInputProps';

export interface DatePickerInputProps<T extends FormikValues>
  extends PickerDateProps<Moment>,
    IExtraInputProps {
  name: keyof T & string;
  type: 'from' | 'to';
}

/**
 * Input per cercare su una data.
 */
export function DatePickerInput<T extends FormikValues>(
  props: DatePickerInputProps<T>
) {
  const { name, type, extraOptions, value, ...otherProps } = props;
  const [field, , helpers] = useField(name);
  const inputProps = useInputProps(props);

  return (
    <DatePicker
      name={name}
      value={dateInputUtils.toMoment(type, value ?? field.value)}
      onOpenChange={status => {
        if (!status) helpers.setTouched(true);
      }}
      format={otherProps.format ?? 'DD/MM/YYYY'}
      onBlur={field.onBlur}
      onChange={(date, raw) => {
        // console.log(
        //   'datepicker',
        //   date,
        //   raw,
        //   dateInputUtils.toString(type, date)
        // );
        helpers.setValue(
          date == null ? null : dateInputUtils.toString(type, date)
        );
      }}
      {...otherProps}
      {...inputProps}
    />
  );
}
